export const isFullStatic = false
export const staticPath = "/home/runner/work/das-webapp/das-webapp/.nuxt/static-json"
export const publicPath = "https://did-app.d.id/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"